<template>
    <div class="modal_bg" @click="fnEvent(false)" v-if="show"></div>
    <div class="pop_layer pop_white" id="pop1" :style="{ display: props.show ? 'block' : 'none' }">
        <div class="pop_hd" :class="title ? '' : 'no_title'">
            <span v-html="title"></span>
            <button type="button" @click="fnEvent(false)">
                <img src="@/assets/board/pop_close.png" alt="" />
            </button>
        </div>
        <div class="pop_content">
            <template v-if="props.content?.main?.data !== ''">
                <div class="pop_content_box">
                    <p class="title" v-if="content.title">{{ content?.title }}</p>
                    <p :class="[content?.main.class]" v-html="fnRender(content.main.data, content.main)"></p>
                </div>

                <div class="pop_content_box" v-if="props.content?.subTitle">
                    <p class="title">{{ content?.subTitle }}</p>

                    <div :class="[content?.sub?.class]" v-html="fnRender(content?.sub?.data, content?.sub)"></div>
                </div>

                <template v-if="props.content?.img?.data">
                    <div class="pop_content_box">
                        <div class="pop_img_header">
                            <p class="title">이미지</p>
                            <button @click="downloadImg(content.img)">다운로드</button>
                        </div>
                        <div class="pop_img">
                            <img class="pop_img" :class="{ blur: content.img.data }" :src="content.img.data" alt="" />
                        </div>
                    </div>
                </template>
            </template>
            <template v-else-if="props.content.img">
                <img class="pop_img" :class="{ blur: content.img.data }" :src="content.img.data" alt="" />
            </template>
            <template v-else>
                <div class="pop_content_box">
                    <Loading :isLoading="true" class="pop_spinner"></Loading>
                </div>
            </template>
        </div>
    </div>
</template>
<script lang="ts">
    import { Spinner, watch } from "@/BaseComponent";

    export default {
        props: {
            title: {
                type: String,
                required: true,
            },
            content: {
                type: Object,
                required: true,
            },
            yes: {
                type: String,
                default: "확인",
            },
            no: {
                type: String,
                default: "취소",
            },
            show: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            Loading: Spinner,
        },
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const fnEvent = (result: boolean) => {
                emit("close", result);
            };

            const fnRender = (data: any, content: any) => {
                if (content.render) {
                    return content.render(data);
                } else {
                    return data;
                }
            };

            const downloadImg = async (file: { data: string; name: string }) => {
                const res = await fetch(file.data);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);

                link.download = file.name;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            watch(
                () => props.show,
                () => {
                    if (props.show) {
                        document.body.style.overflow = "hidden";
                    } else {
                        document.body.style.overflow = "auto";
                    }
                },
            );

            return { props, fnEvent, fnRender, downloadImg };
        },
    };
</script>
<style scoped>
    .pop_spinner {
        position: relative !important;
        padding-top: 50px !;
    }
</style>
<style>
    .pop_layer {
        min-width: 750px;
    }

    .pop_layer .pop_content_box:last-child {
        margin-bottom: 0;
        max-height: 500px;
        overflow-y: auto;
    }
    .pop_con_desc.text {
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
    }
    .pop_layer .thumb_con .txt li .long_txt {
        height: 55px;
    }
    .pop_layer .thumb_con .txt li .pop_con_desc {
        color: #5c5c5c;
        flex: 1;
        word-break: keep-all;
        line-height: 1.1;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .pop_img {
        width: 100%;
    }
    .pop_content_box .pop_img_header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .pop_content_box .pop_img_header button {
        padding: 5px 10px;
        background-color: var(--lightBlue);
        color: white;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
    }
</style>
